import React from 'react'
import { browserHistory } from 'react-router'
import authentication from '../http/auth'

export default class LogoutLink extends React.Component {

  state = {
    disabled: false,
  }

  onClick(e) {
    e.preventDefault()

    if (!this.state.disabled) {
      this.setState({ disabled: true })
    }

    authentication.logout()
    browserHistory.push('/login')
  }

  render() {
    return (
      <a href='#' onClick={this.onClick.bind(this)} disabled={this.state.disabled}>
        { this.props.children ? this.props.children : 'Logout'}
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LogoutLink.js